document.addEventListener('DOMContentLoaded', () => {
  // Safari browser detection for specific fixes
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
  
  // Safari debugging (remove in production)
  const safariLog = (message, data = {}) => {
    if (isSafari) {
      console.log(`[Safari Fix] ${message}`, data)
    }
  }
  
  const $header = document.querySelector('nova-header')
  const $openMenu = $header.querySelector('.js-menu-toggle')
  const $closeMenu = $header.querySelector('.js-menu-close-button')

  const $drawerButtons = $header.querySelectorAll('.js-header-drawer-button')

  const $menuDrawerButtons = [...$drawerButtons].filter(
    (button) => button.dataset.type !== 'search',
  )

  const $headerDrawer = $header.querySelectorAll('.js-header-drawer')

  const $menuDrawer = [...$headerDrawer].filter(
    (drawer) => drawer.dataset.type !== 'search',
  )

  const $searchDrawers = $header.querySelectorAll(
    '.js-header-drawer[data-type="search"]',
  )

  // Safari-specific: Function to immediately fix icon states
  const fixSearchIconStates = () => {
    if (!isSafari) return
    
    safariLog('Fixing icon states...')
    
    $drawerButtons.forEach($button => {
      if ($button.dataset.type === 'search') {
        const $target = $header.querySelector(`#${$button.dataset.target}`)
        const $buttonOpenIcon = $button.querySelector('.js-header-drawer-icon-open')
        const $buttonCloseIcon = $button.querySelector('.js-header-drawer-icon-close')
        
        if ($target && $buttonOpenIcon && $buttonCloseIcon) {
          const isDrawerOpen = $target.hasAttribute('is-open')
          const isButtonOpen = $button.hasAttribute('is-open')
          const isOpenIconHidden = $buttonOpenIcon.classList.contains('visually-hidden')
          const isCloseIconHidden = $buttonCloseIcon.classList.contains('visually-hidden')
          
          safariLog('Icon state check', {
            drawerId: $target.id,
            isDrawerOpen,
            isButtonOpen,
            isOpenIconHidden,
            isCloseIconHidden
          })
          
          // Fix any mismatched states
          if (isDrawerOpen !== isButtonOpen) {
            safariLog('Fixing mismatched open state')
            if (isDrawerOpen) {
              $button.setAttribute('is-open', '')
            } else {
              $button.removeAttribute('is-open')
            }
          }
          
          // Fix icon visibility
          if (isDrawerOpen) {
            if (!isOpenIconHidden) {
              safariLog('Hiding open icon')
              $buttonOpenIcon.classList.add('visually-hidden')
            }
            if (isCloseIconHidden) {
              safariLog('Showing close icon')
              $buttonCloseIcon.classList.remove('visually-hidden')
            }
          } else {
            if (isOpenIconHidden) {
              safariLog('Showing open icon')
              $buttonOpenIcon.classList.remove('visually-hidden')
            }
            if (!isCloseIconHidden) {
              safariLog('Hiding close icon')
              $buttonCloseIcon.classList.add('visually-hidden')
            }
          }
        }
      }
    })
  }

  document.addEventListener('nova:searchDrawer:close', () => {
    safariLog('nova:searchDrawer:close event triggered')
    
    for (const $searchDrawer of $searchDrawers) {
      // Safari-specific: Apply minimum open time protection
      if (isSafari) {
        const openTime = parseInt($searchDrawer.dataset.openTime || '0')
        const now = Date.now()
        const timeSinceOpen = now - openTime
        
        safariLog('Close timing check', {
          drawerId: $searchDrawer.id,
          openTime,
          now,
          timeSinceOpen,
          minTime: 300
        })
        
        if (openTime && timeSinceOpen < 300) {
          const delay = 300 - timeSinceOpen
          safariLog(`Delaying close by ${delay}ms`)
          
          // If drawer was just opened, delay the closing and ensure icon states are fixed
          setTimeout(() => {
            safariLog('Executing delayed close')
            $searchDrawer.hide()
            // Single icon fix after delayed close
            setTimeout(fixSearchIconStates, 100)
          }, delay)
          continue
        }
      }
      
      safariLog('Executing immediate close')
      $searchDrawer.hide()
      
      // Safari-specific: Fix icon states immediately after hiding
      if (isSafari) {
        setTimeout(fixSearchIconStates, 100)
      }
    }
  })

  const handleMenuIconClose = () => {
    $closeMenu?.classList.add('hidden')
    $closeMenu?.setAttribute('aria-hidden', 'true')
    $openMenu?.classList.remove('hidden')
    $openMenu?.removeAttribute('aria-hidden')
    document.dispatchEvent(new CustomEvent('nova:mobile-menu:close'))
  }

  $openMenu?.addEventListener('click', () => {
    $openMenu.classList.add('hidden')
    $openMenu.setAttribute('aria-hidden', 'true')
    $openMenu.setAttribute('tabindex', '-1')

    $closeMenu?.classList.remove('hidden')
    $closeMenu?.removeAttribute('aria-hidden')
    $closeMenu?.setAttribute('tabindex', '0')

    document.dispatchEvent(new CustomEvent('nova:mobile-menu:open'))
  })

  const mobileMenuDrawer = document.getElementById('mobile-menu')

  document.addEventListener('nova:menu:closed-in-modal', () => {
    handleMenuIconClose()
  })

  mobileMenuDrawer?.addEventListener('sl-hide', handleMenuIconClose)
  $closeMenu?.addEventListener('click', handleMenuIconClose)

  const handleInlineMenuDrawer = (event) => {
    const $button = event.target.closest('.js-header-drawer-button')
    if (!$button) return

    const targetReference = $button.dataset.target
    const $target = $header.querySelector(`#${targetReference}`)
    if (!$target) return
    
    const isCloseIcon = event.target.closest('.js-header-drawer-icon-close')

    safariLog('handleInlineMenuDrawer called', {
      buttonType: $button.dataset.type,
      targetId: targetReference,
      isOpen: $button.hasAttribute('is-open'),
      eventType: event.type,
      clickedElement: event.target.className,
      isCloseIcon: !!isCloseIcon
    })

    // Safari-specific: Prevent rapid open/close cycles that cause flashing
    if (isSafari && $target.dataset.type === 'search' && $target.dataset.isChanging === 'true') {
      safariLog('Prevented rapid state change')
      return
    }

    if (event.type !== 'mouseenter') {
      // If close icon was clicked, ALWAYS try to close regardless of button state
      if (isCloseIcon) {
        safariLog('Close icon clicked - forcing close')
        if ($target.dataset.type === 'search') {
          document.dispatchEvent(new CustomEvent('nova:searchDrawer:close'), {
            bubbles: true,
          })
        } else {
          $target.hide()
        }
        return
      }
      
      // For non-close icon clicks, use normal open/close logic
      if ($button.hasAttribute('is-open')) {
        safariLog('Drawer is open, attempting to close')
        if ($target.dataset.type === 'search') {
          document.dispatchEvent(new CustomEvent('nova:searchDrawer:close'), {
            bubbles: true,
          })
        } else {
          $target.hide()
        }
        return
      }
    }

    safariLog('Opening drawer')
    for (const $drawer of $headerDrawer) {
      if ($drawer === $target) {
        if (!$drawer.hasAttribute('is-open')) {
          // Safari-specific: Mark as changing to prevent rapid state changes
          if (isSafari && $drawer.dataset.type === 'search') {
            $drawer.dataset.isChanging = 'true'
            safariLog('Marked drawer as changing')
            setTimeout(() => {
              $drawer.dataset.isChanging = 'false'
              safariLog('Unmarked drawer as changing')
            }, 150) // Increased from 100ms to 150ms
          }
          $drawer.show()
        }
      } else {
        $drawer.hide()
      }
    }
  }

  const closeDrawer = (event) => {
    const $drawer = event.target.closest('.js-header-drawer')
    if (!$drawer) return
    $drawer.hide()
  }

  for (const $button of $drawerButtons) {
    // Use Safari-specific handling for search buttons
    if ($button.dataset.type === 'search') {
      $button.addEventListener('click', (event) => {
        const isCloseIcon = event.target.closest('.js-header-drawer-icon-close')
        
        safariLog('Search button clicked', {
          isCloseIcon: !!isCloseIcon,
          targetClass: event.target.className,
          buttonOpen: $button.hasAttribute('is-open')
        })
        
        // Safari-specific: Prevent rapid events but don't stop propagation if clicking close icon
        if (isSafari) {
          // Only prevent defaults for search icon clicks, not close icon clicks
          if (!isCloseIcon) {
            safariLog('Preventing default for search icon click')
            event.stopPropagation()
            event.preventDefault()
          } else {
            safariLog('Allowing close icon click to proceed normally')
          }
          
          // Process the event and fix icons after delays
          handleInlineMenuDrawer(event)
          // Reduced icon fixing - just one delayed fix
          setTimeout(() => {
            safariLog('Delayed icon fix after click')
            fixSearchIconStates()
          }, 200)
        } else {
          handleInlineMenuDrawer(event)
        }
      }, isSafari) // Use capture phase for Safari
    } else {
      $button.addEventListener('click', handleInlineMenuDrawer)
    }
  }

  const handleDrawerAttributesAndEvents = (event) => {
    const $drawer = event.target.closest('.js-header-drawer')

    if (!$drawer) return
    const targetReference = $drawer.id
    const $button = $header.querySelector(`[data-target="${targetReference}"]`)
    if (!$button) return
    const $buttonOpenIcon = $button.querySelector('.js-header-drawer-icon-open')
    const $buttonCloseIcon = $button.querySelector('.js-header-drawer-icon-close')
    
    safariLog(`Drawer ${event.type} event`, {
      drawerId: targetReference,
      drawerType: $drawer.dataset.type
    })
    
    if (event.type === 'sl-hide') {
      $drawer.removeAttribute('is-open')
      $button.removeAttribute('is-open')
      if ($buttonOpenIcon && $buttonCloseIcon) {
        $buttonOpenIcon.classList.remove('visually-hidden')
        $buttonCloseIcon.classList.add('visually-hidden')
      }
      
      // Safari-specific: Additional icon state fix for search drawers
      if (isSafari && $drawer.dataset.type === 'search') {
        // Clear the openTime when drawer is hidden
        $drawer.dataset.openTime = '0'
        safariLog('Cleared openTime and fixing icons after hide')
        // Reduced to just one delayed fix
        setTimeout(fixSearchIconStates, 100)
      }
      
      dispatchDrawerHideEvent($drawer)
    } else if (event.type === 'sl-show') {
      // Safari-specific: track when drawer was opened for minimum open time protection
      if (isSafari && $drawer.dataset.type === 'search') {
        const openTime = Date.now()
        $drawer.dataset.openTime = openTime.toString()
        safariLog('Set openTime', { openTime })
      }
      
      $drawer.setAttribute('is-open', '')
      $button.setAttribute('is-open', '')
      if ($buttonOpenIcon && $buttonCloseIcon) {
        $buttonOpenIcon.classList.add('visually-hidden')
        $buttonCloseIcon.classList.remove('visually-hidden')
      }
      
      // Safari-specific: Additional icon state fix for search drawers
      if (isSafari && $drawer.dataset.type === 'search') {
        safariLog('Fixing icons after show')
        // Reduced to just one delayed fix
        setTimeout(fixSearchIconStates, 50)
      }
      
      dispatchDrawerShowEvent($drawer)
    }
  }

  const dispatchDrawerShowEvent = (target) => {
    window.dispatchEvent(
      new CustomEvent('nova:header-drawer:open', {
        bubbles: true,
        detail: { target: target },
      }),
    )
  }

  const dispatchDrawerHideEvent = (target) => {
    window.dispatchEvent(
      new CustomEvent('nova:header-drawer:close', {
        bubbles: true,
        detail: { target: target },
      }),
    )
  }

  for (const $drawer of $headerDrawer) {
    $drawer.addEventListener('sl-hide', handleDrawerAttributesAndEvents)
    $drawer.addEventListener('sl-show', handleDrawerAttributesAndEvents)
  }

  for (const $button of $menuDrawerButtons) {
    $button.addEventListener('mouseenter', handleInlineMenuDrawer)
  }

  for (const $drawer of $menuDrawer) {
    $drawer.addEventListener('mouseleave', closeDrawer)
  }
})
